import { api } from '../utils/libs/axios'
import { NewSubmissionPayloadSchema } from '../utils/types/submission'

const getOne = async ({ formId, submissionId }: { formId: string; submissionId: string }) =>
  api(`/v1/submissions/${submissionId}?formId=${formId}`)

/* const uploadFile = async (files: Record<string, any>[]) => {
  const allRequests: any = []
  const allResults: any = []

  files.forEach((newFile) => {
    allRequests.push(
      api.post('/v1/submissions/upload-file', newFile.file, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
    )
  })

  const allRes = await Promise.all(allRequests)
  const uploadData = allRes.map(({ data }) => data)

  files.forEach((file) => {
    const fileUploadData = uploadData.find(({ path }) => file.name === path)
    allResults.push({
      ...fileUploadData,
      questionId: file.questionId
    })
  })

  return allResults
} */

const create = async (payload: NewSubmissionPayloadSchema) => {
  /* if (payload.meta.filesData) {
    const results = await uploadFile(payload.meta.filesData)

    payload.submission.sections.forEach(({ questions }: any) => {
      questions.forEach((question: any) => {
        const questionUploadRes = results.find(
          ({ questionId }: { questionId: string }) => questionId === question.id
        )
        if (questionUploadRes) {
          question.answer = {
            fullPath: questionUploadRes.fullPath,
            id: questionUploadRes.id,
            path: questionUploadRes.path
          }
        }
      })
    })
  } */

  return api.post(`/v1/submissions`, payload)
}

const deleteOne = async (id: string) => api.delete(`/v1/submissions/${id}`)

export const SubmissionService = {
  getOne,
  create,
  deleteOne
}
